<template>
    <van-swipe-cell :on-close="onClose">
        <div class="com-contrast-item" @click="clickItem">
            <div class="com-contrast-item-title">{{source.f_title}}</div>
            <div class="com-contrast-item-content clearfix">
                <div class="com-contrast-item-box dsp-flex" v-for="bzGanZhi in source.bzGZinfo">
                    <div class="com-record-word" v-for="wordValue in bzGanZhi">
                        <p v-bind:class="'wd-' + wordValue[0].propXingEn">{{wordValue[0].text}}</p>
                        <p v-bind:class="'wd-' + wordValue[1].propXingEn">{{wordValue[1].text}}</p>
                    </div>
                </div>
            </div>
        </div>
        <template slot="right">
            <div class="com-record-delete com-contrast-delete">删除</div>
        </template>
    </van-swipe-cell>
</template>

<script>
export default {
    name: 'ContrastListItem',
    props: {
        source: {
            type: Object,
            default() { return {} }
        }
    },
    data() {
        return {
            locked: false
        }
    },
    methods:{
        onClose(clickPosition, instance) {
            var me = this;
            switch(clickPosition) {
                case 'cell':
                case 'outside':
                    instance.close();
                    break;
                case 'right':
                    this.$store.dispatch('contrast/deleteContrast', {
                        delId: this.source.id,
                        cb: ()=> {
                            this.$toast("删除对比成功");
                        }
                    });
                    instance.close();
                    break;
            }
        },
        clickItem() {
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, 1000);
            this.$store.dispatch('contrast/initContrast', {
                contrastData: this.source,
                cb: () => {
                    this.$router.replace('/contrast/contrastlist/'+this.source.id);
                }
            })
        }
    }
}
</script>
